import React, { useEffect, useState, useRef } from 'react'
import Select from 'react-select'
import { useSelector } from 'react-redux';
import { applynewMisApplication, getAllAppliedMISHeaders, getMISAllAppFilled, getMISheaders } from '../../../auth/services/privateapicalling'
import * as XLSX from 'xlsx'
import { toast, ToastContainer } from 'react-toastify';
// import MISPages from './Pages';
import { useNavigate } from 'react-router';


const MISPreview = () => {
    
    const [apiHeaderResponse, setApiHeaderResponse] = useState([])
    const [appliedHeaders, setAppliedHeaders] = useState([])
    
    const [selectedYear, setSelectedYear] = useState('')
    const [selectedHeader, setSelectedHeader] = useState(null)
  
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [showDeadlineModal, setShowDeadlineModal] = useState(false);

 
    // const userDetail = useSelector((state: any) => state.auth.userDetails);
    // const roleIdentifier = userDetail?.Role?.Role_Identifier;
    // const [responseTrue, setResponseTrue] = useState(true) 

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const token = useSelector((state: any) => state.auth.token);
    const navigate = useNavigate();
    useEffect(() => {
        const checkAllAppFilled = async () => {
            try {
                const response = await getMISAllAppFilled(token);
              
                
                if (response?.success && response?.message==="Details not found for all table") {
                    setShowDeadlineModal(true);
                   
                }
            } catch (error) {
              
                setError("Failed to load report types")
            }
        }
        
        checkAllAppFilled();
    }, [token])
    useEffect(() => {
        const fetchHeaders = async () => {
            try {
                const response = await getMISheaders(token);
              
                
                if (response?.success && response?.data) {
                    setApiHeaderResponse(response.data);
                }
            } catch (error) {
             
                setError("Failed to load report types")
            }
        }
        
        fetchHeaders();
    }, [token])

    useEffect(() => {
        const fetchAppliedHeaders = async () => {
            try {
                const response = await getAllAppliedMISHeaders(token,30);
               
                
                if (response?.success && response?.data) {
                    setAppliedHeaders(response.data);
                }
            } catch (error) {
             
                setError("Failed to load report types")
            }
        }
        
        fetchAppliedHeaders();
    }, [token])
    

    // Transform API data to react-select format
    const selectOptions = apiHeaderResponse.map(item => ({
        value: item.id,
        label: "Report: "+item.header_name
    }))

const today = new Date();

const year = today.getFullYear();
const month = today.getMonth(); // 0 = Jan, 3 = Apr
// const month = 3; // For testing April cutoff

const lastCompletedFYEndYear = month >= 3 ? year : year - 1;

// Generate last 2 completed FYs
const yearOptions = Array.from({ length: 2 }, (_, i) => {
  const startYear = lastCompletedFYEndYear - 2 + i;
  const endYear = (startYear + 1).toString().slice(-2);

  const fy = `${startYear}-${endYear}`;

  return {
    value: fy,
    label: fy
  };
});
const currentFY = yearOptions[yearOptions.length - 1].value;



    const handleSubmit =async()=>{
        if(!selectedYear){
            toast.error("Please select Year before submitting.");
            return;
        }
        if(!selectedHeader){
            toast.error("Please select Report Type before submitting.");
            return;
        }
            setLoading(true);
        try{
         const data={
            headerId: selectedHeader?.value,
            year: selectedYear,
         }
         const res= await applynewMisApplication(token, data);
          
            if(res?.success){
toast.success("Navigating to MIS Input page");

 navigate('/mis-input',{
            state:{
                header:selectedHeader,
                year:selectedYear,
                application:res?.data
            }
        })
    }else{
        toast.error(res?.message || "Failed to create MIS application");
        }
    }catch(err){
          
            toast.error("Failed to navigate to MIS Input page");
        }finally{
            setLoading(false);
        }
    }

const handleViewReport = (report: any) => {
  navigate('/mis-my-application', {
    state: {
      selectedHeader: {
        value: report.headerId,
        label: report.headerName
      }
    }
  });
};


    return (
        <div className='page-wrapper'>
            {/* Deadline Modal */}
            {showDeadlineModal && (
            <>
                {/* Backdrop */}
                <div className="modal-backdrop fade show"></div>

                <div
                className="modal fade show d-block"
                tabIndex={-1}
                role="dialog"
                aria-modal="true"
                >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                    {/* Header */}
                    <div className="modal-header bg-warning">
                        <h5 className="modal-title fw-bold text-dark">
                        ⚠ Important Notice
                        </h5>
                        <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowDeadlineModal(false)}
                        ></button>
                    </div>

                    {/* Body */}
                    <div className="modal-body">
                        <p className="mb-2">
                        You are required to complete all <strong>MIS Reports</strong> for the year <strong>{currentFY}</strong> before the deadline.
                        </p>
                        <p className="fw-semibold text-danger mb-0">
                        📅 Deadline: <strong>31st March</strong>
                        </p>
                    </div>

                    {/* Footer */}
                    <div className="modal-footer">
                        {/* <button
                        className="btn btn-secondary me-2"
                        onClick={() => setShowDeadlineModal(false)}
                        >
                        Close
                        </button> */}
                        <button
                        className="btn btn-success"
                        onClick={() => setShowDeadlineModal(false)}
                        >
                        OK
                        </button>
                    </div>

                    </div>
                </div>
                </div>
            </>
            )}

           <div className='p-4'>
                <h2>MIS Dashboard</h2>
                <p>Please enter the corresponding values</p>

                {/* Error message */}
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}

                {/* Success message */}
                {success && (
                    <div className="alert alert-success" role="alert">
                        {success}
                    </div>
                )}

                <div className='d-flex justify-content-between gap-4 mb-3'>   
                    <div className='w-100'>
                        <label className='form-label'>Year <span className="text-danger">*</span></label>
                        <Select
                            options={yearOptions}
                            value={yearOptions.find(opt => opt.value === selectedYear)}
                            onChange={(selectedOption) => setSelectedYear(selectedOption?.value || '')}
                            placeholder="Select Year"
                            isDisabled={loading}
                        />
                    </div>
                    
                    <div className='w-100'>
                        <label className='form-label'>Report Type <span className="text-danger">*</span></label>
                        <Select
                            options={selectOptions}
                            value={selectedHeader}
                            onChange={(selectedOption) => setSelectedHeader(selectedOption)}
                            placeholder="Select Report"
                            isLoading={apiHeaderResponse.length === 0}
                            isDisabled={loading}
                        />
                    </div>
                </div>
               <button 
                    className='btn btn-success'
                    onClick={handleSubmit}
                    // disabled={!selectedYear || !selectedHeader}
                >
                    {loading ? 'Submitting...' : 'Submit'}
                </button>
            </div>
            <div className='m-4'>
                <h4 className='mb-3'>Reports Filled</h4>
                <table className='table table-bordered table-hover'>
                    <thead className='table-light'>
                        <tr>
                            <th style={{width: '10%'}}>Report No.</th>
                            <th style={{width: '80%'}}>Report Name</th>
                            <th style={{width: '10%'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {appliedHeaders.length > 0 &&
                        [...appliedHeaders]
                        .sort(
                            (a, b) =>
                            parseInt(a.headerName.match(/^\d+/)?.[0] || "9999", 10) -
                            parseInt(b.headerName.match(/^\d+/)?.[0] || "9999", 10)
                        )
                        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                        .map((report, index) => {
                            const serialNo = report.headerName.match(/^\d+/)?.[0] || "";
                            const cleanName = report.headerName.replace(/^\d+\.\s*/, "");

                            return (
                            <tr key={`${report.id}-${index}`}>
                                <td className="text-center">{serialNo}</td>
                                <td style={{ whiteSpace: "pre-line" }}>
                                {cleanName}
                                </td>
                                <td>
                                <button
                                    className="btn btn-outline-info w-100"
                                    onClick={() => handleViewReport(report)}
                                >
                                    View
                                </button>
                                </td>
                            </tr>
                            );
                        })}
                    </tbody>
                </table>
                
                {/* Pagination Controls */}
                {appliedHeaders.length > itemsPerPage && (
                <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end align-items-center gap-2 mt-3">

                    {/* Previous */}
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                        className="page-link rounded-circle"
                        onClick={() =>
                            setCurrentPage(prev => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                        >
                        {"<"}
                        </button>
                    </li>

                    {/* Current Page Only */}
                    <li className="page-item active">
                        <span className="page-link rounded-circle">
                        {currentPage}
                        </span>
                    </li>

                    {/* Next */}
                    <li
                        className={`page-item ${
                        currentPage === Math.ceil(appliedHeaders.length / itemsPerPage)
                            ? "disabled"
                            : ""
                        }`}
                    >
                        <button
                        className="page-link rounded-circle"
                        onClick={() =>
                            setCurrentPage(prev =>
                            Math.min(
                                prev + 1,
                                Math.ceil(appliedHeaders.length / itemsPerPage)
                            )
                            )
                        }
                        disabled={
                            currentPage ===
                            Math.ceil(appliedHeaders.length / itemsPerPage)
                        }
                        >
                        {">"}
                        </button>
                    </li>

                    </ul>
                </nav>
                )}
            </div>
       
             <ToastContainer position="top-right" autoClose={3000} />
        </div>
    )
}

export default MISPreview